import { SOP_MODE_ENUM, SOP_MODE_LABELS } from '../../../Constants/sopMode';

export { SOP_MODE_ENUM, SOP_MODE_LABELS };

/** Rosetta without a linked record is treated as free-form (Link CTA + gate blocked). */
export const resolveEffectiveMode = (serverMode, hasLinkedRecord) => {
  const known = Object.values(SOP_MODE_ENUM).includes(serverMode)
    ? serverMode
    : SOP_MODE_ENUM.FREE_FORM;
  if (known === SOP_MODE_ENUM.ROSETTA_VERSION && !hasLinkedRecord) {
    return SOP_MODE_ENUM.FREE_FORM;
  }
  return known;
};

export const MODE_DEFS = [
  {
    key: SOP_MODE_ENUM.FREE_FORM,
    tag: 'Default · no setup',
    title: 'Free-form scope',
    body: 'Where every company starts. The customer types what to measure on each takeoff.',
    idle: 'The fallback state — nothing to set up.'
  },
  {
    key: SOP_MODE_ENUM.LEGACY_SOP,
    tag: 'Existing customers',
    title: 'Legacy SOP setup',
    body: 'The SOP form the team fills in by hand, per company.',
    idle: 'Set up in the legacy SOP form.'
  },
  {
    key: SOP_MODE_ENUM.ROSETTA_VERSION,
    tag: 'Recommended',
    title: 'Rosetta scope record',
    body: 'Link what the customer submitted at intake. No one re-types anything.',
    idle: 'Needs a submitted scope — send an intake link first.'
  }
];

export const buildModes = (current, { hasLinkedRecord = false, sopMode = null } = {}) =>
  MODE_DEFS.map(d => {
    const isCta = d.key === SOP_MODE_ENUM.ROSETTA_VERSION && !hasLinkedRecord;
    const isCurrent = !isCta && d.key === current;
    const variant = isCta ? 'cta' : isCurrent ? 'current' : 'idle';
    const isLegacy = d.key === SOP_MODE_ENUM.LEGACY_SOP;
    const legacyLocked = isLegacy && sopMode === SOP_MODE_ENUM.ROSETTA_VERSION;
    let actionLabel = '';
    if (isLegacy) actionLabel = isCurrent ? 'Edit legacy SOP' : 'Set up legacy SOP';
    return {
      key: d.key,
      variant,
      hasAction: isLegacy,
      actionDisabled: legacyLocked,
      actionLabel,
      tag: isCurrent ? 'Current mode' : d.tag,
      title: d.title,
      body: d.body,
      isCta,
      isStatus: !isCta,
      statusLabel: legacyLocked
        ? 'Not available while this company is on a Rosetta scope record.'
        : isCurrent
          ? 'This company is on this mode'
          : d.idle
    };
  });

export const MODE_LOZENGE_COLOR = {
  [SOP_MODE_ENUM.FREE_FORM]: 'neutral',
  [SOP_MODE_ENUM.LEGACY_SOP]: 'gold',
  [SOP_MODE_ENUM.ROSETTA_VERSION]: 'success'
};
